function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 92,
  r: 18.5,
  stroke: "#FF1523",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M110 93h12.5",
  stroke: "#FF1523",
  strokeWidth: 5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 92,
  r: 18.5,
  stroke: "#FF1523",
  strokeWidth: 3
});

function SvgAccessories0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "static/media/accessories-0.22606e26.svg";
export { SvgAccessories0 as ReactComponent };